import { mergeWithSubmissionModel, fieldToMerge } from '../api/actionUtils';
import { GOOGLE_API_REQUIREMENTS } from '../constants/googleAPI';

export function setAccountDetails({model="submission", accountDetails={}}) {
  const {types = [], ...googleInfo} = accountDetails;

  return dispatch =>  {
    // Google API will return the locality or address as a value for name
    // Google API will return a place_id no matter the type
    // These should only be populated if the place is of type "establishment"

    if (types.includes(GOOGLE_API_REQUIREMENTS.REQUIRED_TYPE)) {
      return mergeWithSubmissionModel({dispatch, googleInfo, model});
    } else {
      Object.keys(googleInfo).forEach(key => dispatch(fieldToMerge({model, key, value: ""})));
    }
  };
}

